import v1 from './v1';
import v2 from './v2';
import v3 from './v3';
import v4 from './v4';
import v5 from './v5';
import v6 from './v6';
import v7 from './v7';
import v8 from './v8';
import v9 from './v9';
import v10 from './v10';
import v11 from './v11';
import v12 from './v12';
import v13 from './v13';
import v14 from './v14';
import v15 from './v15';
import v16 from './v16';
import v17 from './v17';
import v18 from './v18';
import v19 from './v19';
import v20 from './v20';
import v21 from './v21';
import v22 from './v22';
import v23 from './v23';
import v24 from './v24';
import v25 from './v25';
import v26 from './v26';
import v27 from './v27';
import v28 from './v28';
import v29 from './v29';
import v30 from './v30';
import v31 from './v31';
import v32 from './v32';
import v33 from './v33';
import v34 from './v34';
import v35 from './v35';
import v36 from './v36';
import v37 from './v37';
import v38 from './v38';
import v39 from './v39';
import v40 from './v40';
import v41 from './v41';
import v42 from './v42';
import v43 from './v43';
import v44 from './v44';
import v45 from './v45';
import v46 from './v46';
import v47 from './v47';

export const EVENT_WEBSITE_VERSION = 2;
export const PLUGIN_DATA_VERSION = 1;
const versions = [v1, v2, v3, v4, v5, v6, v7, v8, v9, v10, v11, v12, v13, v14, v15, v16, v17, v18, v19, v20, v21,
  v22, v23, v24, v25, v26, v27, v28, v29, v30, v31, v32, v33, v34, v35, v36, v37, v38, v39, v40, v41, v42, v43,
  v44, v45, v46, v47];


/**
 * Migrations for the overall "website" object of the event site editor.
 * @param website
 */
export default function websiteMigrations(website) {
  let newWebsite = { ...website };
  if (!newWebsite.eventVersion) {
    newWebsite.eventVersion = 0;
  }

  while (newWebsite.eventVersion < versions.length) {
    const version = versions[newWebsite.eventVersion];
    newWebsite = version(newWebsite);
  }
  return newWebsite;
}
